// extracted by mini-css-extract-plugin
export default {"item":"SharedGroups_item_Q0Y5B","name":"SharedGroups_name_EFsFr"};